import Cookies from 'js-cookie'
import Base64 from "@/utils/Base64";
import moment from 'moment';

const TokenKey = 'login_data'

export function getToken() {
  let data = getLoginData();
  if (data) {
    return data.token;
  }
  return "";
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey)
}


export function setLoginData(data) {
  if (data) {
    sessionStorage.setItem("login_data", JSON.stringify(data))
  } else {
    sessionStorage.removeItem("login_data")
  }

}

export function getUserId() {
  let data = getLoginData();
  if (data) {
    return data.id;
  }
  return null;
}

export function getRoleIds() {
  let data = getLoginData()
  if (data) {
    return data.roleIds;
  }
  return "";
}

export function getLoginData() {
  let data = sessionStorage.getItem("login_data");
  if (data) {
    data = JSON.parse(data);
    return data;
  }
  return "";
}

export function setJwt(str) {
  if (str) {
    sessionStorage.setItem("login_jwt", str)
  } else {
    sessionStorage.removeItem("login_jwt")
  }
}

export function getUserName() {
  var data = getLoginData();
  if (data) {
    return data.user_name
  }
  return "";
}

export function generateRegisterCode() {
  var base1 = new Base64();
  if (getUserName() == "RENON") {
    return base1.encode(getUserName());
  }
  var code = base1.encode("RENON." + getUserName());
  return code
}

export function getJwt() {
  let data = sessionStorage.getItem("login_jwt");;
  if (data) {
    return data
  }
  return "";
}


export function get_last_login_ip() {
  var data = getLoginData();
  if (data) {
    return data["last_login_ip"]
  }
  return "";
}

export function get_last_login_time() {
  var data = getLoginData();
  if (data) {
    return moment(new Date(data["last_login_time"])).format("YYYY-MM-DD HH:mm:ss")
  }
  return "";
}

const getLengArr = (length) => {
  return Array.from({ length: length }, () =>
    Math.floor(Math.random() * 100000001)
  );
}

export function getParents() {


  // return 3
  let loginData = getLoginData();
  let role = loginData.level;

  // if (role === 7) {
  //   // return [...loginData.parents]
  //   return Array.from({ length: role }, () =>
  //     Math.floor(Math.random() * 100000001)
  //   );
  // } else if (role == 0) {
  //   return [loginData.user_name]
  // }
  // return "";

  if (!role) {
    return []
  }
  if (role === 1) { // =1 表示主账户（RENON） Agent Level
    return [loginData.user_name]
  } 

  if (role == 2) { // ZGRP Factory
    return [loginData.parent_name, loginData.user_name]
  }

  if (role == 3) { // HOMEGRID Agent I
    let arr = getLengArr(1)
    return [loginData.parent_name, loginData.user_name, ...arr]
  }

  if (role == 4) { // Agent II
    let arr = getLengArr(2)
    return [loginData.parent_name, loginData.user_name, ...arr]
  }

  if (role == 5) { // Installation Company
    let arr = getLengArr(3)
    return [loginData.parent_name, loginData.user_name, ...arr]
  }

  if (role == 6) { // Installer
    let arr = getLengArr(4)
    return [loginData.parent_name, loginData.user_name, ...arr]
  }

  if (role >= 7) { // 老代码的时候 5 表示终端用户 End User
    let arr = getLengArr(role - 2)
    return [loginData.parent_name, loginData.user_name, ...arr]
  }
}

export function getRoleId() {
  //
  //
  // return 3

  let loginData = getLoginData();
  let role = loginData.level;

  if (!role) {
    return null
  }
  if (role === 1) { // =1 表示主账户（RENON） Agent Level
    return 0
  } 

  if (role == 2) { // ZGRP Factory
    return 1
  }

  if (role == 3) { // HOMEGRID Agent I
    return 2
  }

  if (role == 4) { // Agent II
    return 3
  }

  // homegrid 少一个层级
  if (role == 5) { // Installation Company
    return 4
  }

  // homegrid 少一个层级
  if (role == 6) { // Installer
    return 5
  }

  if (role >= 7) { // 老代码的时候 5 表示终端用户 End User
    return 5
  }

  // return role >= 2 ? role - 1 : role;

  // let loginData = getLoginData();
  // let role = loginData.role;
  // if (role === 0) {
  //   return 1;
  // } else if (role !== 6) {
  //   return null;
  // }

  // let parents = loginData.parents;
  // if (!parents) {
  //   return null;
  // }
  // parents = parents.filter(item => {
  //   return item != loginData["username"]
  // })

  // // console.log(parents,"parents")
  // let length = parents.length;
  // if (length > 4) {
  //   return 5;
  // }
  // return length;

}

export function getRoleIdRenon() {
  //
  //
  // return 3
  let loginData = getLoginData();
  let role = loginData.level;

  if (role === 1) {
    return 0;
  } else {
    return 1
  }



}
